import { motion } from "framer-motion";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Bento } from "../components/Bento";
import { EoiLink } from "../components/EoiLink";

const MILESTONES = [
  { date: "NOW", label: "Expressions of interest open" },
  { date: "TO BE CONFIRMED", label: "Information evenings" },
  { date: "JAN 2027", label: "Term 1 begins — doors open" },
];

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <Bento />

      <section className="mx-auto max-w-5xl px-4 pb-20 sm:px-6 lg:px-12">
        <motion.p
          data-testid="motto-statement"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-center font-serif text-2xl font-medium leading-snug text-navy sm:text-3xl lg:text-4xl"
        >
          Growing minds. <span className="text-gold">Building character.</span>{" "}
          Create belonging. <span className="text-gold">Preparing leaders.</span>
        </motion.p>
      </section>

      <section id="key-dates" className="mx-auto max-w-7xl scroll-mt-24 px-4 pb-20 sm:px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative overflow-hidden rounded-3xl bg-navy p-8 sm:p-12 md:p-16"
        >
          <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-gold/15 blur-3xl" />
          <div className="relative">
            <p className="mb-3 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-gold">
              <CalendarDays className="h-4 w-4" /> Key Dates
            </p>
            <h2 className="max-w-xl font-serif text-2xl font-semibold text-white sm:text-3xl lg:text-4xl">
              The road to opening day
            </h2>

            <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {MILESTONES.map((m, i) => (
                <motion.div
                  key={m.date}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                  className="border-l-2 border-gold/60 pl-4"
                  data-testid={`key-date-${i}`}
                >
                  <p className="font-mono text-xs tracking-[0.2em] text-gold">{m.date}</p>
                  <p className="mt-2 text-sm leading-relaxed text-slate-200">{m.label}</p>
                </motion.div>
              ))}
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-4 border-t border-white/10 pt-8">
              <EoiLink
                testid="cta-eoi-button"
                className="group flex items-center gap-2.5 rounded-full bg-gold px-12 py-6 text-lg font-semibold text-black shadow-xl shadow-gold/30 transition-all duration-200 hover:bg-gold-hover hover:shadow-2xl hover:shadow-gold/40 active:scale-95"
              >
                Express Your Interest
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </EoiLink>
              <p className="font-mono text-[11px] tracking-[0.2em] text-slate-400">
                YEARS 7–10 · FOUNDATION INTAKE 2027
              </p>
            </div>
          </div>
        </motion.div>
      </section>
    </main>
  );
}
